import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import useIsMobile from "../../hooks/Helper/useIsMobile";
import { Loader } from "../../components/Loader/Loader";
import logo from "../../assets/success.png";
import { useParams } from "react-router-dom";
import iconImage from "../../assets/images/user-image.png";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { useSelector } from "react-redux";
import {
  createCertConnect,
  searchContactbyCCOId,
} from "../../redux/thunks/certConnectThunks";
import { getActiveDesignations } from "../../redux/thunks/designationThunks";
import {
  closeModal,
  openModal,
  toggleModal,
} from "../../redux/slices/modalSlice";
import { FaInfoCircle, FaSearch, FaUpload, } from "react-icons/fa";
import * as XLSX from "xlsx";
import { setBulkData } from "../../redux/slices/bulkUploadSlice";
import { BulkUpdate } from "../../types/bulkUpdate";
import Swal from "sweetalert2";
import { validateCertConnectBulkUpload } from "../../redux/thunks/bulkUpdateThunk";
import { setSearchContact } from "../../redux/slices/certConnectSlice";
import { getCCOsNeedAttentionByOrgId } from "../../redux/thunks/ccoAdvanceTab2Thunk";
import {
  useTheme
} from "@mui/material";
import "../../sass/base/SearchContactCCOAdvance.scss";
import MyConnectionSection from "../MyCCOPro/MyConnectionSection";
import { BulkUploadModal } from "../../components/Modals/BulkUploadModal";
import BulkUploadInfoModal from "../../components/Modals/BulkUploadInfoModal";
import RequestSentModal from "../../components/Modals/CertRequestSentModal";


type ContactSearchForm = {
  CCOId: string;
  OrgId?: string;
};

Modal.setAppElement("#root");

export const SearchContact = () => {
  const { register, handleSubmit, reset } = useForm<ContactSearchForm>();
  const { organizationId } = useParams();
  const [_showEligibilityInfo, setShowEligibilityInfo] = useState(false);
  const isMobile = useIsMobile();
  const theme = useTheme();
  const isInfoModalOpen = useSelector(
    (state: RootState) => state.modals.bulkUploadInfoModal
  );
  const { t } = useTranslation();


  const dispatch = useDispatch<AppDispatch>();
  const {
    searchContact,
    searchLoading,
    searchError,
    requestLoading,
  } = useSelector((state: RootState) => state.certConnect);
  const { requestSentModal } = useSelector(
    (state: RootState) => state.modals
  );


  useEffect(() => {
    dispatch(getActiveDesignations());
    handleGlobalClick(true);
  }, []);

  const { sortBy, sortOrder } = useSelector(
    (state: RootState) => state.ccoAdvance
  );

  const onSubmit = (data: ContactSearchForm) => {
    dispatch(
      searchContactbyCCOId({ CCOId: data.CCOId, OrgId: organizationId })
    );
  };


  const filterMenuRef = useRef(null);
  const sortMenuRef = useRef<HTMLDivElement>(null);

  const { bulkUpdateList } = useSelector(
    (state: RootState) => state.bulkUpload
  );
  const prevHasData = useRef(false);
  useEffect(() => {
    const hasData = bulkUpdateList && bulkUpdateList.length > 0;

    if (prevHasData.current === true && hasData === false) {
      handleGlobalClick(true);
    }
    prevHasData.current = hasData;
  }, [bulkUpdateList]);

  const handleRequestAccess = async () => {
    await dispatch(
      createCertConnect({
        ContactId: searchContact.ContactId,
        OrganizationId: organizationId,
      })
    );

    dispatch(setSearchContact(null));
    dispatch(toggleModal("requestSentModal"));
    reset();
  };



  const handleClickOutside = (e: MouseEvent) => {
    if (
      filterMenuRef.current &&
      !filterMenuRef.current.contains(e.target as Node)
    ) {
      dispatch(closeModal("filterModal"));
    }

    if (
      sortMenuRef.current &&
      !sortMenuRef.current.contains(e.target as Node)
    ) {
      dispatch(closeModal("sortModal"));
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleGlobalClick = (isReset: boolean = false) => {
  };
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleBulkUploadClick = () => {

    dispatch(openModal("bulkUploadInfoModal"));
  };

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const allowedExtensions = ["xlsx", "xls", "csv"];
    const extension = file.name.split(".").pop()?.toLowerCase();

    if (!extension || !allowedExtensions.includes(extension)) {
      Swal.fire({
        title: t("bulkUpload.InvalidFile"),
        html: `
           <p>${t("bulkUpload.OnlyFilesAllowed")}<b>.xlsx, .xls, </b> ${t(
          "bulkUpload.And"
        )} <b>.csv</b>  ${t("bulkUpload.Only")}</p>

    <div style="text-align:center; margin-top:8px;">
      <a 
        href="/bulk-fileUpload-guidance.pdf" 
        target="_blank" 
        rel="noopener noreferrer"
        class="swal-guideline-link"
      >
        ${t("bulkUpload.GuideLine")}
      </a>
    </div>
  `,
        confirmButtonColor: "#C67B05",
        customClass: {
          popup: "bulk-modal-style",
        },
      });

      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = e.target?.result;
      if (!data) return;

      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];

      const sheetRows = XLSX.utils.sheet_to_json<any>(
        workbook.Sheets[sheetName],
        { header: 1 }
      ) as any[][];

      if (sheetRows.length > 0) {
        const numCols = Math.max(...sheetRows.map((r) => r.length));
        const columnStartRows: number[] = [];

        for (let col = 0; col < numCols; col++) {
          let startRow = -1;
          for (let row = 1; row < sheetRows.length; row++) {
            const cell = sheetRows[row][col];
            if (
              cell !== undefined &&
              cell !== null &&
              cell.toString().trim() !== ""
            ) {
              startRow = row;
              break;
            }
          }
          columnStartRows.push(startRow);
        }
        const headerRow = sheetRows[0] || [];
        const hasDataBelowEmptyHeader = sheetRows
          .slice(1)
          .some((row) =>
            row.some(
              (cell, colIndex) =>
                cell !== undefined &&
                cell !== null &&
                cell.toString().trim() !== "" &&
                (!headerRow[colIndex] ||
                  headerRow[colIndex].toString().trim() === "")
            )
          );

        if (hasDataBelowEmptyHeader) {
          Swal.fire({
            title: t("bulkUpload.InvalidFile"),
            html: `<p>${t("bulkUpload.ColumnHeader")}</p>
             <a href="/bulk-fileUpload-guidance.pdf" target="_blank" rel="noopener noreferrer" 
                style="color:#c67b05; font-weight:500; font-size:15px; text-decoration:underline;">
                ${t("bulkUpload.GuideLine")}
             </a>`,
            confirmButtonColor: "#C67B05",
            customClass: {
              popup: "bulk-modal-style",
            },
          });

          if (fileInputRef.current) fileInputRef.current.value = "";
          dispatch(setBulkData([]));
          return;
        }
        const filledColumns = columnStartRows.filter((index) => index !== -1);
        if (filledColumns.length > 0) {
          const firstStartRow = Math.min(...filledColumns);
          const misalignedCols = columnStartRows
            .map((start, idx) =>
              start !== -1 && start !== firstStartRow ? idx : -1
            )
            .filter((idx) => idx !== -1);
          const misaligned = misalignedCols.length > 0;
          if (misaligned) {
            Swal.fire({
              title: t("bulkUpload.InvalidFile"),
              html: `<p>${t("bulkUpload.SameRow")}</p>
         <a href="/bulk-fileUpload-guidance.pdf" target="_blank" rel="noopener noreferrer" 
            style="color:#c67b05; font-weight:500; font-size:15px; text-decoration:underline; cursor:pointer;">
            ${t("bulkUpload.GuideLine")}
         </a>`,
              confirmButtonColor: "#C67B05",
              customClass: {
                popup: "bulk-modal-style",
              },
            });

            if (fileInputRef.current) fileInputRef.current.value = "";
            dispatch(setBulkData([]));
            return;
          }
        }
      }

      const sheet = XLSX.utils.sheet_to_json<any>(workbook.Sheets[sheetName]);
      if (sheet.length > 500) {
        Swal.fire({
          title: t("bulkUpload.Title"),
          text: t("bulkUpload.Text"),
          confirmButtonColor: "#C67B05",
          customClass: {
            popup: "bulk-modal-style",
          },
        });

        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      const normalizedSheet = sheet.map((row) => {
        const newRow: any = {};
        Object.keys(row).forEach((key) => {
          const normalizedKey = key.trim().toLowerCase();
          let finalKey = normalizedKey;
          let count = 1;
          while (newRow[finalKey] !== undefined) {
            finalKey = `${normalizedKey}_${count++}`;
          }
          newRow[finalKey] = row[key];
        });
        return newRow;
      });

      const ccoidColumns = Object.keys(normalizedSheet[0] || {}).filter((key) =>
        key.includes("ccoid")
      );

      const bulkArray: BulkUpdate[] = [];

      ccoidColumns.forEach((col) => {
        normalizedSheet.forEach((row) => {
          if (row[col]) {
            bulkArray.push({
              Name: null,
              Message: [],
              CCOID: row[col].toString().trim() || null,
              Eligible: null,
              myccoProfile: null,
            });
          }
        });
      });

      const uniqueBulkArray = Array.from(
        new Map(bulkArray.map((item) => [item.CCOID, item])).values()
      );

      dispatch(setBulkData(uniqueBulkArray));
      dispatch(openModal("bulkUploadModal"));
      const arr = uniqueBulkArray.map((item) => item.CCOID);
      await dispatch(
        validateCertConnectBulkUpload({
          orgId: organizationId,
          CCOId: arr,
        })
      );

      setShowEligibilityInfo(true);
    };

    reader.readAsBinaryString(file);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  return (
    <div className="search-contact-container">
      <form onSubmit={handleSubmit(onSubmit)} className="add_connection">
        <div className="search-header">
          <h2>{t("MyCCOPro.SearchCandidate.addCandidates")}</h2>
        </div>

        <label className="form-label"></label>

        <div className="SearchContact">
          <input
            {...register("CCOId", {
              required: true,
              setValueAs: (v) => v.trim(),
            })}
            placeholder={t("MyCCOPro.SearchCandidate.enterIdPlaceholder")}
            className="SearchContact_input"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmit(onSubmit)();
              }
            }}
          />

          <button type="submit" className="SearchContact_icon">
            <FaSearch className="search-icon" />
          </button>
        </div>
      </form>
      <div className="bulk-upload-row">
        {!isMobile && (
          <div className="bulk-upload-text">
            <span className="bulk-upload-span">
              <b>{t("bulkUpload.ForLargeGroups")},{" "}</b>
              <span
                onClick={handleBulkUploadClick}
                className="bulk-upload-link"
              >
                <b>{t("bulkUpload.UseBulkUpload")}</b>
              </span>
            </span>
          </div>
        )}
        {/* Hidden File Input */}
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          accept=".xlsx,.xls"
          onChange={handleFileUpload}
        />
      </div>
      {searchLoading && (
        <div className="loader-wrapper">
          <Loader />
        </div>
      )}

      {!searchLoading &&
        (searchError ? (
          <div className="error-wrapper">
            <p className="error-text">
              {String(
                searchError
                  ? typeof searchError === "string"
                    ? searchError
                    : t(searchError.key as string, searchError.params as any)
                  : ""
              )}{" "}
            </p>
          </div>
        ) : searchContact ? (
          <div className="search-result-card">
            <div className="search-result-photo">
              <img
                src={searchContact.ProfilePicture || iconImage}
                alt={searchContact.ContactFullName || "Profile"}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = iconImage;
                }}
              />
            </div>

            <div className="details">
              <h3>{searchContact.ContactFullName || "Name not available"}</h3>
              <p>
                <strong>{t("MyCCOPro.CCOID")}</strong>{" "}
                {searchContact.CCOId || "N/A"}
              </p>

              <button
                onClick={handleRequestAccess}
                disabled={requestLoading}
                className="request-btn"
              >
                {requestLoading
                  ? t("MyCCOPro.SearchCandidate.requesting")
                  : t("MyCCOPro.SearchCandidate.requestAccess")}
              </button>
            </div>
          </div>
        ) : null)}


      <RequestSentModal
        isOpen={requestSentModal}
        logo={logo}
        onConfirm={() => handleGlobalClick(true)}
      />

      <BulkUploadModal organizationId={organizationId} />
      <MyConnectionSection />

      <BulkUploadInfoModal
        isOpen={isInfoModalOpen}
        fileInputRef={fileInputRef}
        onFileUpload={handleFileUpload}
      />
    </div>
  );
};
